import { $mount } from '../../../js/dom-lifecycle';

$mount('.ea-fileupload input[type="file"]').on('change', function (e) {
    const self = this;
    const file = e.originalEvent.target.files[0];
    const fileReader = new FileReader();
    const extension = file.name.split('.').slice(-1)[0];
    const imageExtensions = JSON.parse($(this).attr('image-extensions'));
    const videoExtensions = JSON.parse($(this).attr('video-extensions'));
    const embedExtensions = JSON.parse($(this).attr('embed-extensions'));

    clearPreview(this);

    fileReader.onload = (function (file) {
        return function (event) {
            if ($.inArray(extension, imageExtensions) !== -1) {
                $(self).closest('.file-container').find('.image-preview').removeClass('d-none');
                $(self).closest('.file-container').find('.image-preview img').attr('src', fileReader.result);
            } else if ($.inArray(extension, videoExtensions) !== -1) {
                $(self).closest('.file-container').find('.video-preview').removeClass('d-none');
                $(self).closest('.file-container').find('.video-preview source').attr('src', fileReader.result);
                $(self).closest('.file-container').find('.video-preview video')[0].load();
            } else if ($.inArray(extension, embedExtensions) !== -1) {
                $(self).closest('.file-container').find('.embed-preview').removeClass('d-none');
                $(self).closest('.file-container').find('.embed-preview embed').attr('src', fileReader.result);
            }
        };
    })(file);

    fileReader.readAsDataURL(file);
});

$mount('.ea-fileupload-delete-btn').on('click', function () {
    clearPreview(this);
});

function clearPreview(element) {
    $(element).closest('.file-container').find('.image-preview').addClass('d-none');
    $(element).closest('.file-container').find('.image-preview img').attr('src', '');

    $(element).closest('.file-container').find('.video-preview').addClass('d-none');
    $(element).closest('.file-container').find('.video-preview source').attr('src', '');

    $(element).closest('.file-container').find('.embed-preview').addClass('d-none');
    $(element).closest('.file-container').find('.embed-preview embed').attr('src', '');
}
